<template>
  <div>
    <v-row>
      <v-col cols="4">
        <input-documento @change="changeDocumento" cnpj label="CNPJ" v-model="model.Subscritor.DocumentoFederal"
          :rules="() => $api.Proposta.ValidaDocumentoEmitente(model.Cliente.DocumentoFederal, model.Subscritor.DocumentoFederal)"
          required />
      </v-col>
      <v-col cols="8">
        <input-text label="Razão Social" v-model="model.Subscritor.Nome" required />
      </v-col>
    </v-row>
    <v-row class="pl-4">
      <span class="subtitle-1">Informações de Contato</span>
    </v-row>
    <v-row>
      <v-col cols="12">
        <input-phone v-model="model.Subscritor.PessoaDadosContato.TelefoneFixo1" label="Telefone Fixo" tel />
      </v-col>
    </v-row>
    <v-row class="pl-4">
      <v-col class="pa-0">
        <DadosEndereco v-model="model.Subscritor.PessoaEndereco" title="Informações de Endereço"/>
      </v-col>
    </v-row>
    <v-row class="pl-4">
      <span class="subtitle-1 mr-2">Dados da Administradora</span>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="primary" dark v-bind="attrs" v-on="on">
            fa fa-question-circle
          </v-icon>
        </template>
        <span>Se o Subscritor for FIDC</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col cols="4">
        <input-documento cnpj label="CNPJ" v-model="model.Subscritor.CNPJAdmEmpresa"
          :rules="() => $api.Proposta.ValidaDocumentoEmitente(model.Subscritor.DocumentoFederal, model.Subscritor.CNPJAdmEmpresa)" />
      </v-col>
      <v-col cols="8">
        <input-text label="Razão Social" v-model="model.Subscritor.RazaoSocialAdmEmpresa" />
      </v-col>
    </v-row>
    <v-subheader>Informações Bancárias</v-subheader>
    <v-row>
      <v-col cols="12" class="pa-0">
        <input-seleciona-banco required v-model="model.Subscritor.PessoaBanco" />
      </v-col>
      <v-col cols="12" class="pt-0">
        <input-radiogroup row v-model="model.Subscritor.PessoaBanco.TipoConta" @change="changeAgencia" required
          name="Tipo Conta">
          <v-radio :value="2">
            <template slot="label">
              <span class="mr-2">Conta corrente</span>
            </template>
          </v-radio>
          <v-radio :value="3">
            <template slot="label">
              <span class="mr-2">Conta pagamento</span>
            </template>
          </v-radio>
        </input-radiogroup>
      </v-col>
      <v-col cols="6">
        <input-text required :disabled="model.Subscritor.PessoaBanco.TipoConta === 3"
          v-model="model.Subscritor.PessoaBanco.Agencia" label="Agência" v-mask="['####', '####-#']" />
      </v-col>
      <v-col cols="6">
        <input-text required v-model="model.Subscritor.PessoaBanco.Conta" label="Conta"
          v-mask="$api.UI.Format.MascaraDigito(15)" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return { }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
    changeDocumento () {
      const th = this
      th.carregaDados(th.model.Subscritor.DocumentoFederal)
    },
    changeAgencia () {
      const th = this
      if (th.model.Subscritor.PessoaBanco.TipoConta === 3) {
        th.$set(th.model.Subscritor.PessoaBanco, 'Agencia', '0001')
      } else {
        th.$set(th.model.Subscritor.PessoaBanco, 'Agencia', null)
      }
    },
    submit (callback) {
      const th = this
      const Dto = {
        dto: {
          CodigoProposta: th.model.Codigo,
          CodigoOperacao: th.model.CodigoOperacao,
          NumeroProposta: th.model.CodigoProposta,
        },
        NotaComercial: {
          Codigo: th.model.CodigoNotaComercial ? th.model.CodigoNotaComercial : null,
          CodigoProposta: th.model.Codigo,
          RazaoSocial: th.model.Subscritor.Nome,
          DocumentoFederal: th.model.Subscritor.DocumentoFederal,
          Email: th.model.Subscritor.PessoaDadosContato.Email,
          TelefoneCelular: th.model.Subscritor.PessoaDadosContato.TelefoneCelular1,
          Logradouro: th.model.Subscritor.PessoaEndereco.Logradouro,
          NroLogradouro: th.model.Subscritor.PessoaEndereco.NroLogradouro,
          Complemento: th.model.Subscritor.PessoaEndereco.Complemento,
          Bairro: th.model.Subscritor.PessoaEndereco.Bairro,
          Cidade: th.model.Subscritor.PessoaEndereco.Cidade,
          UF: th.model.Subscritor.PessoaEndereco.UF,
          CEP: th.$api.UI.Format.SomenteNumeros(th.model.Subscritor.PessoaEndereco.CEP),
          CodigoBanco: th.model.Subscritor.PessoaBanco.NroBanco,
          Banco: th.model.Subscritor.PessoaBanco.Banco,
          TipoConta: th.model.Subscritor.PessoaBanco.TipoConta,
          Agencia: th.model.Subscritor.PessoaBanco.Agencia,
          ContaSubscritor: th.model.Subscritor.PessoaBanco.Conta,
          RazaoSocialAdmEmpresa: th.model.Subscritor.RazaoSocialAdmEmpresa,
          CNPJAdmEmpresa: th.model.Subscritor.CNPJAdmEmpresa,
        }
      }
      th.$api.Multiplo.IncluirNotaComercial(Dto).then((response) => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.model.CodigoNotaComercial = response.Codigo
          if (callback) callback()
        } else {
          th.$api.UI.ShowError('Erro', response.error)
        }
      })
    },
    async carregaDados (documento) {
      const th = this
      const obj = await th.$api.Multiplo.CarregaDadosPessoa(documento)
      if (obj) {
        th.$set(th.model.Subscritor, 'Nome', obj.Nome);
        if (obj.PessoaDadosContato) {
          th.$api.UTIL.Functions.SetAllButNull(th, th.model.Subscritor, 'PessoaDadosContato', obj.PessoaDadosContato)
          th.$set(th.model.Subscritor.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(obj.PessoaDadosContato.TelefoneCelular1))
          th.$set(th.model.Subscritor.PessoaDadosContato, 'TelefoneFixo1', obj.PessoaDadosContato.TelefoneFixo1 ? th.$api.UI.Format.Telefone(obj.PessoaDadosContato.TelefoneFixo1) : '')
        }
        if (obj.PessoaDadosEndereco) {
          th.$api.UTIL.Functions.SetAllButNull(th, th.model.Subscritor, 'PessoaEndereco', obj.PessoaDadosEndereco)
        }
      } else {
        th.$set(th.model, 'Subscritor', {
          Nome: null,
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
          DocumentoFederal: documento,
        })
      }
    }
  },
}
</script>
